import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import { useLocation, useNavigate, useParams } from 'react-router';
import styles from '../../../styles/modules/RegistrationSetup.module.css'
import { getFieldName, getFieldsByType, getFormattedDate } from '../Registration/RegistrationHelper';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { EventAPI } from '../../../api/EventAPI';

const EditPlayerInfo = () => {
    const { eventId } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [formData, setFormData] = useState([]);
    const [formFieldsWithSection, setFormFieldsWithSection] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    const [yupObject, setYupObject] = useState({})



    const getAllFormFieldsWithSection = async () => {
        try {
            setIsLoading(true)
            const response = await FormTemplateAPI.getAllFormFieldsWithSectionByEvent(selectedClub.clubId, eventId);
            console.log("Form Fields with Section Response: ", response);
            setFormFieldsWithSection(response.Data);
            if (Object.keys(formData).length === 0) {
                await setInitialValue(response.Data);
            }
            getRequiredFields(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleCheckFieldError = async () => {
        try {
            await yupObject?.validate(formData, { abortEarly: false });
        } catch (error) {
            let errObj = {};
            error.inner.forEach(err => {
                errObj[err.path.split(".")[0]] = {
                    ...errObj[err.path.split(".")[0]], [err.path.split(".")[1]]: err.message
                }
            })
            console.log(errObj);
            
            setFieldErrors(errObj);
            return Object.keys(errObj).length != 0;
        }
    };

    const setInitialValue = (formFields) => {
        return new Promise((resolve) => {
            let initialValue = {};

            formFields?.forEach((fs) => {
                fs.formFields.forEach((ff) => {
                    const fieldName = getFieldName(ff);
                    initialValue[fs.sectionId] = {
                        ...initialValue[fs.sectionId],
                        [fieldName]: ff.type === 'date' ? getFormattedDate(dayjs(new Date())) : null
                    };
                })
            });

            Object.entries(state?.playerFullInfo[0])?.forEach(([fsKey, fsVal]) => {
                const sectionId = fsKey.split('&&&&')[0];
                Object.entries(fsVal).forEach(([ffKey, ffVal]) => {
                    initialValue[sectionId] = {
                        ...initialValue[sectionId],
                        [ffKey]: ffVal
                    };
                })
            })

            setFormData(initialValue);
            resolve();
        });
    };


    const handleUpdatePlayerInfo = async () => {
        try {
            const isError = await handleCheckFieldError();
            console.log(isError);
            
            if (isError) {
                return;
            }
            setIsLoading(true);
            const info = state.playerFullInfo.map((data, idx) => {
                if (idx === 0) {
                    return {
                        data: formData,
                        stepName: "Player Info",
                        stepNumber: 0
                    }
                } else if (idx === 1) {
                    return {
                        data: data,
                        stepName: "Participant Fee",
                        stepNumber: 1
                    }
                } else if (idx === 2) {
                    return {
                        data: data,
                        stepName: "Waiver",
                        stepNumber: 2
                    }
                } else if (idx === 3) {
                    return {
                        data: data,
                        stepName: "Payment",
                        stepNumber: 3
                    }
                }
            })

            await EventAPI.putUpdateEventPlayerInfo({
                eventId: eventId,
                playerId: state.playerId,
                playerRegistrationInfo: JSON.stringify(info)
            });
            navigate(-1);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getRequiredFields = (formFields) => {
        let initialState = {};

        formFields?.forEach((fs) => {
            fs.formFields.forEach((ff) => {
                const fieldName = getFieldName(ff);
                if (!fs.isRemovable && fieldName === 'relation' && state?.isPlayer) {

                } else if (ff.isRequired) {
                    initialState[fs.sectionId] = {
                        ...initialState[fs.sectionId],
                        [fieldName]: ff.type === 'date' ? getFormattedDate(dayjs(new Date())) : ''
                    };
                }
            })
        });

        const yupObj = Yup.object(
            Object.entries(initialState).reduce((acc, [sectionKey, fields]) => {
                acc[sectionKey] = Yup.object(
                    Object.keys(fields).reduce((fieldAcc, fieldKey) => {
                        fieldAcc[fieldKey] = Yup.string().required(`${fieldKey?.replaceAll("_", " ")} is required`);
                        return fieldAcc;
                    }, {})
                );
                return acc;
            }, {})
        );
        setYupObject(yupObj);
    };
    useEffect(() => {
        if (selectedClub.clubId) {
            getAllFormFieldsWithSection();
        }
    }, [selectedClub.clubId]);

    const handleCollectData = useCallback((event, sectionId) => {
        const { name, value } = event.target;
        setFormData(prev => ({
            ...prev,
            [sectionId]: {
                ...(prev[sectionId] || {}),
                [name]: value
            }
        }));
    }, []);
    const isChildrenFieldDisabled = (isRemovable, fieldDataName) => {
        const fieldName = fieldDataName?.replaceAll(" ", "_").toLowerCase();
        if (!isRemovable && (fieldName === 'first_name' || fieldName === 'last_name' || fieldName === 'date_of_birth' || fieldName === 'relation')) {
            return true;
        } else {
            return false
        }
    }

    if (isLoading) {
        return <CustomContainerLoader />
    }
    return (
        <div style={{ padding: '10px' }}>
            {formFieldsWithSection?.map((section, index) =>
                <div key={index} className={styles['form_overview_sections']}>
                    <h1>{section?.sectionName}</h1>
                    <div className={styles['form_overview_sections_fields']}>
                        {
                            section?.formFields?.filter(item => state?.isPlayer ? (item.name !== 'Relation' || item.isRemovable) : item).map((field, index) =>
                                (field.type !== 'checkbox' && field.type !== 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], isChildrenFieldDisabled(field.isRemovable,
                                                field?.name), fieldErrors[section?.sectionId])
                                        }

                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_radio_fields']}>
                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], false, fieldErrors[section?.sectionId])
                                        }
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_checkbox_fields']}>

                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'checkbox' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], false, fieldErrors[section?.sectionId])
                                        }
                                        <span style={{ height: 5 }}></span>
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                </div>
            )}
            <div className={styles['update_info_btn_con']}>
                <button onClick={handleUpdatePlayerInfo} className={styles['update_info_btn']}>Save</button>
            </div>
        </div>
    )
}

export default EditPlayerInfo